import {
  Anchor,
  Button,
  Card,
  Center,
  Divider,
  Stack,
  ThemeIcon,
  Title,
  TypographyStylesProvider,
  Image,
} from "@mantine/core";

import React from "react";
import DocsHighlightCard from "../articlesHelpers/DocsHighlightCard";
import { IconAt, IconFileInvoice } from "@tabler/icons-react";
import DocsButton from "../articlesHelpers/DocsButton";
import SimpleImage from "../articlesHelpers/SimpleImage";

export const SEND_TO_LIGHTNING_ADDRESS_CONTENT = (
  <TypographyStylesProvider>
    <p>
      Your first option for sending lightning payments is to send to a lightning
      address.
    </p>
    <DocsButton
      ariaLabel="send lightning address"
      text="Pay to Lightning Address"
      leftSection={<IconAt />}
    />
    <p>
      {" "}
      A lightning address looks like an email address -- like user@domain.com --
      but otherwise lightning addresses and email addresses don't have much in
      common. When you choose this option, you'll start with a blank form where
      you can type or paste an address:
    </p>

    <SimpleImage h={150} src="docs_images/pay-to-lighting-address-blank.png" />
    <p>
      You'll find that if you put a random email address, say,
      example@example.com, into the form, you'll get an error message...
    </p>
    <SimpleImage h={150} src="docs_images/errored-lightning-address.png" />

    <p>
      This happens because, when you enter a lightning address, Rizful Node
      looks up the server that hosts that address, and will return an error if
      the address doesn't exist.
    </p>

    <p>
      If however, the address IS valid, you'll then get to a confirmation
      screen:
    </p>

    <SimpleImage
      h={400}
      src="docs_images/confirm-pay-to-lightning-address.png"
    />

    <p>Let's discuss each of these options.</p>

    <p>
      The <strong>Amount (Satoshis) </strong> indicates how many satoshis you
      will be sending. This amount is limited by your outbound capacity. If you
      try to send more than your outbound capacity, you'll see an error message
      like:
    </p>

    <SimpleImage
      h={150}
      src="docs_images/pay-to-lightning-address-amount-too-large.png"
    />
    <p>
      Also, keep in mind that the receiver of your payment must have sufficient
      inbound capacity to receive your payment... And, one of the most difficult
      things about lightning payments is that it's often difficult to know how
      much inbound capacity any particular node has at a given time. If your
      payee does not have sufficient capacity, the payment will fail with a
      vague error message like "No Route Found." Fun!
    </p>
    <p>
      So, a good practice is, when sending to a new payment address, to start
      with a small amount, say 1000 satoshis, and then increase the amount if
      the payment is successful.
    </p>

    <p>
      Next, in the <strong>Message For Recipient</strong> field, you can add a
      message to the recipient. This message is optional and can (usually) be up
      to about 140 characters long.
    </p>

    <p>
      {" "}
      Finally, if you have more than 100,000 satoshis in your Rizful node, you
      will have been required to set up two-factor authentication (2FA), so
      you'll need to enter your six-digit 2FA code, from your authenticator app,
      to initiate the payment.
    </p>
  </TypographyStylesProvider>
);
